import {
  Store,
  Search,
  Users,
  Truck,
  Building2,
  Megaphone,
  Globe2,
  Link2,
  Compass,
  Network,
  Package,
  Factory,
  Box,
  Warehouse,
  ShoppingBag,
  User,
  Briefcase,
  Wrench,
  Lightbulb,
  MonitorSmartphone,
  Handshake,
  MessageSquareText,
  Map,
  CalendarClock,
  Eye,
  Target,
  Sparkles,
} from "lucide-react";

export const whyUseItems = [
  { icon: Store, text: "Create a professional digital Business Showcase" },
  {
    icon: Search,
    text: "Make products, services and capabilities easier to discover",
  },
  {
    icon: Users,
    text: "Reach potential customers and business connections",
  },
  {
    icon: Truck,
    text: "Find suppliers, manufacturers, wholesalers and other resources",
  },
  {
    icon: Building2,
    text: "Discover transportation, property, recruitment and professional services",
  },
  {
    icon: Megaphone,
    text: "Promote products, services, announcements and business capabilities",
  },
  {
    icon: Globe2,
    text: "Explore regional and international business opportunities",
  },
  { icon: Link2, text: "Build relationships across different business sectors" },
  {
    icon: Compass,
    text: "Discover resources needed to start, operate or expand a business",
  },
  {
    icon: Network,
    text:
      "Use SELECTEZI as a connected business environment rather than relying on one business relationship at a time",
  },
];

export const sectorFlow = [
  { icon: Package, label: "RAW MATERIAL" },
  { icon: Factory, label: "MANUFACTURER" },
  { icon: Box, label: "PACKAGING" },
  { icon: Truck, label: "TRANSPORTATION" },
  { icon: Warehouse, label: "WHOLESALER" },
  { icon: ShoppingBag, label: "RETAILER" },
  { icon: User, label: "CUSTOMER" },
];

export const roleValues = [
  {
    icon: User,
    title: "Small Business",
    text: "Visibility, Customers, Suppliers, Services, Opportunities",
  },
  {
    icon: MonitorSmartphone,
    title: "Growing Business",
    text: "Markets, Employees, Resources, Partners, Technology",
  },
  {
    icon: Building2,
    title: "Large Company",
    text: "Business Network, Supply Chain Connections, Regional Visibility, New Relationships",
  },
  {
    icon: User,
    title: "Service Provider",
    text: "Customers, Businesses, Partnerships, Visibility",
  },
  {
    icon: Factory,
    title: "Manufacturer",
    text: "Raw Materials, Equipment, Employees, Transport, Wholesale, Retail",
  },
  {
    icon: Briefcase,
    title: "Customer",
    text: "Products, Services, Businesses, Resources, Opportunities",
  },
  {
    icon: Lightbulb,
    title: "Entrepreneur",
    text: "Ideas, Resources, Suppliers, Services, Customers, Opportunities",
  },
  {
    icon: MonitorSmartphone,
    title: "Technology Company",
    text: "Business Customers, Distribution, Partnerships, Market Access",
  },
  {
    icon: Users,
    title: "Strategic Partner",
    text: "Technology, Infrastructure, Customers, Distribution, Market Access, Ecosystem Integration",
  },
];

export const connectionNodes = [
  {
    key: "person",
    label: "PERSON",
    note: "People find products & jobs",
  },
  {
    key: "business",
    label: "BUSINESS",
    note: "Businesses find customers & resources",
  },
  {
    key: "resource",
    label: "RESOURCE",
    note: "Suppliers find businesses",
  },
  {
    key: "service",
    label: "SERVICE",
    note: "Service providers find organizations",
  },
  {
    key: "opportunity",
    label: "OPPORTUNITY",
    note: "People find jobs & opportunities",
  },
  {
    key: "technology",
    label: "TECHNOLOGY",
    note: "Technology companies find businesses needing digital solutions",
  },
  {
    key: "partner",
    label: "PARTNER",
    note: "Partners contribute technology, infrastructure, distribution, marketing & strategic value",
  },
  {
    key: "distribution",
    label: "DISTRIBUTION",
    note: "Businesses find distribution & logistics partners",
  },
  {
    key: "marketing",
    label: "MARKETING",
    note: "Businesses find customers through marketing",
  },
];

export const connectionDiscoverList = [
  "People can discover products, services, jobs, businesses and opportunities",
  "Businesses can discover customers and the resources behind their operations",
  "Suppliers can discover businesses that need their resources",
  "Service providers can discover organizations that need their capabilities",
  "Technology companies can discover businesses that need digital solutions",
  "Partners can discover opportunities to contribute technology, infrastructure, distribution, marketing or strategic value",
];

export const journeySteps = [
  { icon: Store, label: "SHOWCASE" },
  { icon: Search, label: "GET DISCOVERED" },
  { icon: Users, label: "CONNECT" },
  { icon: Megaphone, label: "PROMOTE" },
  { icon: Handshake, label: "FIND RESOURCES" },
  { icon: Sparkles, label: "CREATE OPPORTUNITIES" },
  { icon: Target, label: "GROW" },
];

export const journeyPills = [
  "CREATE SHOWCASE",
  "GET DISCOVERED",
  "CONNECT",
  "PROMOTE",
  "FIND RESOURCES",
  "CREATE OPPORTUNITIES",
  "GROW",
];

export const marketingCards = [
  { icon: Store, text: "Promote the business Showcase" },
  { icon: MessageSquareText, text: "Promote selected products and services" },
  { icon: Map, text: "Support regional promotion" },
  { icon: CalendarClock, text: "Support seasonal and special campaigns" },
  { icon: Eye, text: "Improve business presentation and discoverability" },
  { icon: Target, text: "Help identify relevant business and customer opportunities" },
  {
    icon: Sparkles,
    text: "Combine human marketing support with SELECTEZI AI capabilities where available",
  },
];

export const ecosystemSpine = [
  { num: "01", title: "Raw Material", desc: "Extraction & Harvest Supply" },
  { num: "02", title: "Manufacturer", desc: "Industrial Assembly & Production" },
  { num: "03", title: "Packaging", desc: "Encasement & Brand Labeling" },
  { num: "04", title: "Transportation", desc: "Fleet Freight & Route Logistics" },
  { num: "05", title: "Wholesaler", desc: "Bulk Distribution Hubs" },
  { num: "06", title: "Retailer", desc: "Direct-to-Market Merchandising" },
  { num: "07", title: "Customer", desc: "End-User & Commercial Buyer", highlight: true },
];

export const ecosystemOrbit = [
  "Telecom",
  "Property",
  "Marketing",
  "Jobs",
  "Internet",
  "Advertising",
  "Services",
  "Cloud",
  "Logistics",
  "Technology",
  "Professional Services",
  "Banking",
  "AI",
];

export const consumerJourney = [
  "CONSUMER",
  "RESOURCE SEEKER",
  "RESOURCE PROVIDER",
  "SELLER / SERVICE PROVIDER",
  "ENTREPRENEUR",
  "BUSINESS OWNER",
  "OPPORTUNITY CREATOR",
];

export const footerLinks = [
  "JOIN SELECTEZI",
  "CREATE YOUR SHOWCASE",
  "EXPLORE BUSINESSES",
  "FIND WHAT YOU NEED",
  "SHOW WHAT YOU HAVE",
  "DISCOVER OPPORTUNITIES",
  "START YOUR BUSINESS JOURNEY",
  "PROMOTE YOUR BUSINESS",
  "EXPLORE PREMIUM",
  "PARTNER WITH SELECTEZI",
  "INVEST IN SELECTEZI",
];
